import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { ETHOS_VERBS, ETHOS_PROMISE } from '@/lib/ethosCopy';

// Understand · Organise · Connect · Act: the four verbs, each opening its part of the portal.
export default function EthosVerbs({ onNavigate }) {
  return (
    <section className="py-14" data-testid="ethos-verbs">
      <div className="container mx-auto px-4 max-w-6xl">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2">How FBC helps</p>
        <h2 className="text-2xl md:text-3xl font-semibold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>Understand. Organise. Connect. Act.</h2>
        <p className="text-sm md:text-base text-muted-foreground max-w-2xl mb-8">{ETHOS_PROMISE}</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {ETHOS_VERBS.map((v, i) => (
            <motion.button
              key={v.key}
              type="button"
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              onClick={() => onNavigate(v.section)}
              className="group text-left rounded-xl border bg-card p-5 hover:border-primary/50 hover:shadow-md transition-[box-shadow,border-color]"
              data-testid={`ethos-verb-${v.key}`}
            >
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs font-mono text-muted-foreground">0{i + 1}</span>
                <v.icon className="h-5 w-5 text-primary" />
              </div>
              <h3 className="font-semibold text-lg mb-1">{v.label}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{v.body}</p>
              <span className="mt-3 inline-flex items-center text-xs font-medium text-primary opacity-70 group-hover:opacity-100 transition-opacity">Open <ArrowRight className="h-3.5 w-3.5 ml-1 group-hover:translate-x-0.5 transition-transform" /></span>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
